import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@material-ui/core'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import AttachmentImage from 'app/main/composeMessage/attachments/attachmentImage'
import clsx from 'clsx'
import * as R from 'ramda'

const Gallery = (props) => {
  const { data = [] } = props
  const { mes_4367_attachment_gallery } = useFeatureFlag()

  const sortedImages = useMemo(() => {
    if (!data || data.length === 0) return data
    const selectedImage = R.find(R.prop('isSelected'), data)
    if (!selectedImage) return data
    const otherImages = R.reject(R.prop('isSelected'), data)
    return [selectedImage, ...otherImages]
  }, [data])

  return (
    <div className="py-10 relative">
      <Typography className="text-primary font-bold text-16">
        <FormattedMessage
          id="timeline.detail.message.attachment.title"
          values={{
            count: sortedImages.length,
          }}
        />
      </Typography>
      <div className="overflow-x-auto overflow-y-hidden w-full my-5">
        <div className="flex flex-nowrap w-max pb-5">
          {sortedImages?.map((item, index) => {
            const imageData = {
              url: item.url,
              name: item.fileName,
              isSelected: item.isSelected == 1,
            }

            return (
              <div
                key={`atteched-medias-${index}`}
                className={clsx(index < sortedImages.length - 1 && 'mr-5')}
              >
                <AttachmentImage
                  image={imageData}
                  isPreview={true}
                  showFeatured
                  className={mes_4367_attachment_gallery ? '' : '[&>p]:hidden'}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const valuePropTypes = {
  mediaId: PropTypes.number,
  type: PropTypes.string,
  fileName: PropTypes.string,
  url: PropTypes.string,
  socialType: PropTypes.string,
  isSelected: PropTypes.number,
}
Gallery.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)).isRequired,
}

export default Gallery
